
import firebase from '@/firebaseInit.js';
import i18n from '@/i18n.js'

export default {
    data() {
        return {

            refPlattformConfig: firebase.firestore().collection('config'),
            refUsers: firebase.firestore().collection('users'),

            versionDatePrivacyPolicyPlatform: null,
            versionDatePrivacyPolicyUser: null,

        };
    },

  
    
    methods: {
      verifyPrivacyPolicyRead(userId){
        //Carrega a data de politica de privacidade da plataforma
        this.refPlattformConfig.doc("version").get().then(version =>{
            this.versionDatePrivacyPolicyPlatform = version.data().datePrivacyPolicy
           
            //Carrega a data de politica de privacidade do usuario  
            this.refUsers.doc(userId).get().then(user => {
                this.versionDatePrivacyPolicyUser  =  user.data().datePrivacyPolicy
                
                //console.log(this.versionDatePrivacyPolicyUser)
                //console.log(this.versionDatePrivacyPolicyPlatform)

                if(this.versionDatePrivacyPolicyUser == null | this.versionDatePrivacyPolicyUser < this.versionDatePrivacyPolicyPlatform){
                   
                    this.$store.commit('setPrivacyPolicyOk', false)
                    this.$store.commit('setShowSavedPrivacyPolicy', false)

                    this.$bvModal.msgBoxOk(i18n.t('msgPolicyPrivacy'), {
                        title: i18n.t('msgTitleInfo'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                   
                    if(this.$router.currentRoute.path != "/privacypolicy")
                        this.$router.push("/privacypolicy")

                }else if(this.versionDatePrivacyPolicyUser > this.versionDatePrivacyPolicyPlatform){
                    this.$store.commit('setPrivacyPolicyOk', true)
                    this.$store.commit('setShowSavedPrivacyPolicy', true)
                    
                    if(!this.$store.state.privacyPolicyPage)
                        this.$router.push("/listActs")
                }
                // else{
                   
                //     if(this.$route.path != "/listActs")
                //         this.$router.push("/listActs")
                // }

            }) ; 
        })
      }
    }
}

